// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import './scss/_element-variables.scss'

import AppAPI from '@/api'

import './scss/style.scss'

Vue.config.productionTip = false

if (process.env.NODE_ENV !== 'production') console.log(`Bootstraping ${store.getters['app/name']}...`)

/**
 * パスカルケースからケバブケースへ変換
 *
 * @see https://gist.github.com/nblackburn/875e6ff75bc8ce171c758bf75f304707
 */
// function PascalToKebab (string) {
//   return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
// }

/**
 * コンポーネント群を読み込んでVueに登録
 */
AppAPI.componentsArray.forEach(item => {
  Vue.component(item.meta.name, () => import('./components/' + item.meta.type + '/' + item.meta.file + '/' + item.meta.file))
})

Vue.use(ElementUI, { locale })

/**
 * Define global variables
 */
Vue.mixin({})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js